import { DTO__number_range } from '@shared/dto/generation/settings/DTO__number_range';

export class DTO__color_hsl_range {
  /*
   * FIELDS
   */
  hue: number;
  saturation: DTO__number_range;
  lightness: DTO__number_range;

  /*
   * METHODS
   */

  constructor(
    hue: number = 0,
    saturation: DTO__number_range = DTO__number_range.CREATE_STUB(),
    lightness: DTO__number_range = DTO__number_range.CREATE_STUB(),
  ) {
    this.hue = hue;
    this.saturation = saturation;
    this.lightness = lightness;
  }

  get_value(percentage: number = 1.0): string {
    let target_saturation = this.saturation.get_percentage(percentage);
    let target_lightness = this.lightness.get_percentage(percentage);

    return `hsl(${this.hue}, ${target_saturation}%, ${target_lightness}%)`;
  }
}
